const ALERT_TYPES = {
  SHOW: "SHOW",
  HIDE: "HIDE"
};

export default ALERT_TYPES;